import { Text } from '@findy-code/yuffie/ui/text';
import Link from 'next/link';

import styles from './mobile-navigation.component.module.scss';

type NavigationItemProps = {
  icon: React.ReactNode;
  label: string;
  isUnread?: boolean;
  isActive?: boolean;
  url: string;
};

const NavigationItem = ({
  icon,
  label,
  isUnread,
  isActive,
  url,
}: NavigationItemProps) => {
  return (
    <li
      className={isActive ? styles.mobileNavItemActive : styles.mobileNavItem}
    >
      <Link href={url}>
        <Text font="caption-s">{label}</Text>
        <div className={styles.badge}>
          {icon}
          {isUnread && <span aria-label="未読"></span>}
        </div>
      </Link>
    </li>
  );
};

export const MobileNavigation = ({
  activePage,
  unreadNotificationsJobDescriptionLikeCount,
  unreadMessageCount,
}: {
  activePage?: 'recommends' | 'likes' | 'matches' | 'companies';
  unreadNotificationsJobDescriptionLikeCount: number;
  unreadMessageCount: number;
}) => {
  return (
    <nav className={styles.mobileNav}>
      <ul className={styles.mobileNavBar}>
        <NavigationItem
          icon={
            <svg
              aria-hidden
              className={styles.icon}
              fill="currentColor"
              height="20"
              viewBox="0 0 21 20"
              width="21"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.2824 15.8354L15.1666 12.7195C15.0259 12.5789 14.8353 12.5008 14.6353 12.5008H14.1259C14.9884 11.3976 15.501 10.01 15.501 8.50048C15.501 4.90959 12.5914 2 9.00048 2C5.40959 2 2.5 4.90959 2.5 8.50048C2.5 12.0914 5.40959 15.001 9.00048 15.001C10.51 15.001 11.8976 14.4884 13.0008 13.6259V14.1353C13.0008 14.3353 13.0789 14.5259 13.2195 14.6666L16.3354 17.7824C16.6292 18.0762 17.1042 18.0762 17.3948 17.7824L18.2793 16.898C18.5731 16.6042 18.5731 16.1292 18.2824 15.8354ZM9.00048 12.5008C6.79094 12.5008 5.00018 10.7131 5.00018 8.50048C5.00018 6.29094 6.78781 4.50018 9.00048 4.50018C11.21 4.50018 13.0008 6.28781 13.0008 8.50048C13.0008 10.71 11.2131 12.5008 9.00048 12.5008Z"
                fill="#155AA8"
              />
            </svg>
          }
          isActive={activePage === 'recommends' || activePage === 'companies'}
          label="求人検索"
          url="/recommends?utm_source=findy-code&utm_medium=site&utm_campaign=header"
        />
        <NavigationItem
          icon={
            <svg
              aria-hidden
              className={styles.icon}
              fill="currentColor"
              height="20"
              viewBox="0 0 21 20"
              width="21"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.5709 10.9591C17.845 10.495 18 10 18 9.40156C18 8.02609 16.8369 6.72719 15.3181 6.72719H14.1781C14.3319 6.32688 14.4547 5.84812 14.4547 5.27281C14.4547 2.998 13.2769 2 11.4775 2C9.55228 2 9.66209 4.96666 9.235 5.39375C8.52416 6.10459 7.68453 7.47022 7.08625 8H4C3.44772 8 3 8.44772 3 9V16.5C3 17.0523 3.44772 17.5 4 17.5H6C6.46541 17.5 6.8565 17.1821 6.96806 16.7516C8.35897 16.7828 9.31369 17.9997 12.5244 17.9997C12.75 17.9997 13 18 13.2188 18C15.6287 18 16.7183 16.768 16.7481 15.0209C17.1643 14.4452 17.3825 13.6734 17.29 12.9275C17.5979 12.3509 17.717 11.6668 17.5709 10.9591ZM15.6412 12.6412C16.0337 13.3016 15.6806 14.1853 15.2056 14.4403C15.4462 15.9647 14.6554 16.4997 13.5456 16.4997H12.3638C10.125 16.4997 8.67534 15.3178 7 15.3178V9.5H7.34125C8.2275 9.5 9.46563 7.28469 10.2956 6.45437C11.1819 5.56812 10.8866 4.09094 11.4775 3.5C12.9547 3.5 12.9547 4.53063 12.9547 5.27281C12.9547 6.49687 12.0684 7.04531 12.0684 8.22719H15.3181C15.9778 8.22719 16.4972 8.81812 16.5 9.40906C16.5028 9.99969 16.0994 10.5906 15.8041 10.5906C16.2256 11.0455 16.3157 12.0042 15.6412 12.6412ZM5.75 15.5C5.75 15.9142 5.41422 16.25 5 16.25C4.58578 16.25 4.25 15.9142 4.25 15.5C4.25 15.0858 4.58578 14.75 5 14.75C5.41422 14.75 5.75 15.0858 5.75 15.5Z"
                fill="#155AA8"
              />
            </svg>
          }
          isActive={activePage === 'likes'}
          isUnread={!!unreadNotificationsJobDescriptionLikeCount}
          label="いいね"
          url="/likes?utm_source=findy-code&utm_medium=site&utm_campaign=header"
        />
        <NavigationItem
          icon={
            <svg
              aria-hidden
              className={styles.icon}
              fill="currentColor"
              height="20"
              viewBox="0 0 21 20"
              width="21"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17 4H4C3.17156 4 2.5 4.67156 2.5 5.5V14.5C2.5 15.3284 3.17156 16 4 16H17C17.8284 16 18.5 15.3284 18.5 14.5V5.5C18.5 4.67156 17.8284 4 17 4ZM17 5.5V6.77516C16.2993 7.34575 15.1823 8.233 12.7942 10.103C12.2679 10.5169 11.2254 11.5115 10.5 11.4999C9.77475 11.5116 8.73191 10.5168 8.20584 10.103C5.81813 8.23328 4.70078 7.34584 4 6.77516V5.5H17ZM4 14.5V8.69994C4.71606 9.27028 5.73153 10.0706 7.27931 11.2826C7.96234 11.8203 9.1585 13.0072 10.5 13C11.8349 13.0072 13.0159 11.8375 13.7204 11.2829C15.2682 10.0709 16.2839 9.27034 17 8.69997V14.5H4Z"
                fill="#155AA8"
              />
            </svg>
          }
          isActive={activePage === 'matches'}
          isUnread={!!unreadMessageCount}
          label="メッセージ"
          url="/matches?utm_source=findy-code&utm_medium=site&utm_campaign=header"
        />
      </ul>
    </nav>
  );
};
